<template>
  <div class="layout">
    <div class="layout-header">
      <h2 class="layout-logo"><router-link style="color: #333;" :to="{ name: 'Home' }">众悦出行&middot;管理平台</router-link></h2>
      <div class="layout-user" v-if="isLogin()">
        <span class="userinfo">{{ username }}</span>
        <a class="logout" @click="isLogout()">退出</a>
      </div>
    </div>
    <div class="layout-content">
      <Row>
        <Col span="5" style="overflow: auto;" v-if="isLogin()">
          <menu-bar></menu-bar>
        </Col>
        <Col style="overflow: auto;" v-bind:span="isLogin() ? '19' : '25'">
          <div class="layout-content-main">
            <router-view></router-view>
          </div>
        </Col>
      </Row>
    </div>
    <div class="layout-copy">
      {{getYear()}} &copy; 众悦出行 鲁ICP备19000164号-1
    </div>
  </div>
</template>
<script>
  import MenuBar from './components/Common/MenuBar'
  export default {
    name: 'app',
    data() {
      return {
        username : ''
      }
    },
    components: {MenuBar},
    created() {
      if(!Lockr.get('token')) {
        this.$router.replace({ name: 'Login' })
      }
    },
    methods: {
      getNickName() {
        if(Lockr.get('user')) {
          let user = Lockr.get('user')
          this.username = user.name ? user.name : user.username
        }
      },
      isLogin() {
        this.getNickName()
        return Lockr.get('token') ? true : false
      },
      getYear() {
        let date = new Date()
        return date.getFullYear()
      },
      isLogout() {
        this.$Modal.confirm({
          title: '温馨提示',
          content: '<p>确定要退出吗？</p>',
          onOk: () => {
            this.logout()
          }
        });
      },
      logout() {
        Lockr.flush()
        this.$router.replace({ name: 'Login' })
      }
    }
  }
</script>

<style lang="less">
  body, html {
    height: 100%;
    overflow: hidden;

    .layout{
      border: 1px solid #d7dde4;
      background: #f5f7f9;
      height: 100%;

      .layout-header{
        height: 60px;
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);

        .layout-logo{
          height: 30px;
          float: left;
          position: relative;
          top: 15px;
          left: 20px;
          color: #999;
        }
        .layout-user {
          float: right;
          position: relative;
          top: 15px;
          right: 20px;

          .ivu-avatar {
            vertical-align: middle;
          }
          .userinfo {
            font-weight: bolder;
            color: #666;
            font-size: 14px;
          }
        }
      }

      .layout-content {
        min-height: 200px;
        margin: 15px;
        overflow: auto;
        background: #fff;
        border-radius: 4px;
        height: calc(~"100% - 140px");

        .layout-content-main {
          padding: 10px;
        }

        .ivu-row, .ivu-col, .layout-content-main {
          height: 100%;
        }
      }

      .layout-copy{
        text-align: center;
        padding: 10px 0 20px;
        color: #9ea7b4;
      }
    }
  }
  

  .dialog_big_pic {
    max-width: 100%; 
    display: block; 
    margin: 0 auto;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue